<template>
    <div>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader mx-width bg-primary text-light">
            <div class="pageTitle left">
                Masuk
            </div>
            <div class="right">
                <router-link :to="{name:'care-center'}" class="headerButton">
                    <div>
                        <p style="font-size: 10px;line-height: 1.5;margin: 0;width: 80px;text-align: right;">Hubungi<br>Qiosfin Care</p>
                    </div>
                    <ion-icon class="icon ml-1" name="chatbox-ellipses"></ion-icon>
                </router-link>
            </div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule">
            <div class="section form-card-section pt-3">
                <div class="text-center mb-3" style="position:relative;">
                    <img :src="require('@/assets/image/logo_header_white.png')" alt="logo" height="50px;">
                </div>
                <div class="form-card">
                    <div class="form-group basic">
                        <label class="label text-center mb-1">Nomor Handphone</label>
                        <input type="number" class="form-control form-control-lg text-center p-0" placeholder="Contoh : 081234567890" v-model="auth_data.phone">
                    </div>
                    <div class="form-group mb-1 mt-1 text-center" style="line-height:normal;">
                        <small>Dengan melakukan Login berarti anda telah menyetujui <router-link :to="{name:'tos'}"><b>Syarat & Ketentuan</b></router-link> dan <router-link :to="{name:'privacy'}"><b>Kebijakan Privasi</b></router-link> {{ VUE_ENV.VUE_APP_NAME }}</small>
                    </div>
                    <div class="form-group basic mt-1">
                        <ButtonLoader :loading="loading.button" :styled="'btn btn-primary btn-block btn-lg'" @click.native="submit()">Masuk</ButtonLoader>
                        <router-link :to="{name:'auth.register'}" class="btn btn-outline-primary btn-block">~ Belum punya akun? Daftar Sekarang ~</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
export default {
    name: 'auth.login',
    data() {
        return {
            toast_time: 2000
        }
    },
    created(){
        this.$store.commit('SET_TOAST', {show:false})
        this.RESET_AUTH_DATA()
        if (this.isAuth) {
            this.$router.push({ name: 'home' })
        }
    },
    computed:{
        ...mapGetters(['isAuth']),
        ...mapState(['loading','toast','VUE_ENV']),
        ...mapState('auth',{
            auth_data: state => state.auth_data,
        }),
    },
    methods:{
        ...mapActions('auth', ['login']),
        ...mapMutations('auth',['RESET_AUTH_DATA']),
        submit(){
            this.$store.commit('SET_LOADING', {button:true})
            this.$store.commit('SET_TOAST', {show:false})
            this.login(this.auth_data).then(() => {
                this.$store.commit('SET_LOADING', {button:false})
                this.$router.push({ name: 'auth.login.verify' })
            }).catch((error) => {
                this.toast_value = true
                this.$store.commit('SET_LOADING', {button:false})
                this.$store.commit('SET_TOAST', {show:true,message:error.data.message,tipe:'default',icon:'danger'})
            })
        },
    },
    mounted(){
        document.body.classList.add('bg-white')
    },
    destroyed() {
        this.$store.commit('RESET_LOADING')
        this.$store.commit('RESET_TOAST')
    },
}
</script>